import React from 'react';

const H6 = props => <h6 className={'ds-h6'} {...props}>{props.children}</h6>;

export default H6; 